export { my } from '@payloadcms/translations/languages/my'
